import { formatDate } from "@angular/common";
import moment from "moment";

export class PurchaseOrderUtils {
  private static mediumDate(value: string) {
    const format = "d MMM y";
    const locale = "es";
    return formatDate(this.formatDate(value), format, locale).replace(/\w\S*/g, (w) =>
      w.replace(/^\w/, (c) => c.toUpperCase())
    );
  }
  public static billing_chain_naming(docs) {
    let output = [];
    let naming = (doc) => {
      switch (doc.category) {
        case "purchase_order_invoice_process_evidence":
          switch (true) {
            case doc?.metadata?.annex_bill:
              return `Justificación del ${this.mediumDate(doc.metadata.bill_date)}`;
            case doc.metadata.main:
              return `Factura Origen del ${this.mediumDate(doc.metadata.bill_date)}`;
            case !doc.metadata.main:
              return `Factura del ${this.mediumDate(doc.metadata.bill_date)}`;
          }
        case "purchase_order_invoice_endorsement":
          return `Endoso ${naming(docs.find((d) => d.id == doc.metadata.main_document_id))}`;
      }
    };
    return docs.map((d) => naming(d));
  }

  public static repuve_naming(docs) {
    let doc = docs[0];
    let output = "";
    if (doc.metadata.annex) {
      output += "Anexo ";
    }
    output += `REPUVE ${this.mediumDate(doc.metadata.reference_date)}`;
    return [output];
  }

  public static fee_naming(docs) {
    return docs.map(
      (d) => `${d.category == "purchase_order_payment_proof" ? "Comprobante de pago " : ""}Ejercicio ${d.metadata.year}`
    );
  }

  public static enroll_naming(docs) {
    let output = [];
    let naming = (doc) => {
      switch (doc.category) {
        case "purchase_order_registration_procedure":
          if (doc.metadata.annex) {
            return `Justificación del ${this.mediumDate(doc.metadata.reference_date)}`;
          } else {
            return `Comprobante Alta del ${this.mediumDate(doc.metadata.reference_date)}`;
          }
        case "purchase_order_payment_proof":
          return `Comprobante de pago (${naming(docs.find((d) => d.id == doc.metadata.main_document_id))})`;
      }
    };
    return docs.map((d) => naming(d));
  }

  public static disenroll_naming(docs) {
    let output = [];
    let naming = (doc) => {
      switch (doc.category) {
        case "purchase_order_cancellation_procedure":
          if (doc.metadata.annex) {
            return `Justificación del ${this.mediumDate(doc.metadata.reference_date)}`;
          } else {
            return `Comprobante Baja del ${this.mediumDate(doc.metadata.reference_date)}`;
          }
        case "purchase_order_payment_proof":
          return `Comprobante de pago (${naming(docs.find((d) => d.id == doc.metadata.main_document_id))})`;
      }
    };
    return docs.map((d) => naming(d));
  }

  public static circulation_card_naming(docs) {
    let doc = docs[0];
    let output = "";
    if (doc.metadata.annex) {
      output += "Anexo Justificación ";
    }
    output += "Tarjeta de Circulación";
    return [output];
  }

  public static verification_naming(docs) {
    let doc = docs[0];
    let output = "";
    if (doc.metadata.annex) {
      output += "Anexo Justificación ";
    }
    output += "Verificación";
    return [output];
  }

  public static infractions_naming(docs) {
    let output = [];
    let naming = (doc) => {
      if (doc.metadata.commitment_letter) {
        return `Evidencia ${doc.metadata.evidence_index + 1} Carta de Compromiso`;
      } else if (doc.metadata.annex) {
        return `Evidencia ${doc.metadata.evidence_index + 1} Justificación con Anexo`;
      } else {
        if (doc.metadata.evidence_file_type == "processing_proof") {
          return `Evidencia ${doc.metadata.evidence_index + 1} Comprobante de Trámite`;
        } else if (doc.category == "purchase_order_verify_infractions") {
          return "Infracciones faltantes";
        } else {
          return `Evidencia ${doc.metadata.evidence_index + 1} Comprobante de Pago`;
        }
      }
    };
    return docs.map((d) => naming(d));
  }

  public static annexes_naming(docs) {
    return docs.map((d) => `annex [${d.id}]`);
  }

  public static docs_to_string(step, docs) {
    //TODO implement sorting by category
    docs = docs.sort((a, b) => {
      return a.id - b.id;
    });
    let docs_titles = this[step + "_naming"](docs);
    if (docs_titles[0] == undefined && (step == "disenroll" || step == "enroll")) {
      let type = (step = "enroll") ? "Altas" : "Bajas";
      docs_titles = "Evidencia de " + type + " Incompletas";
    }
    docs.forEach((d, i) => (d["title"] = docs_titles[i]));
    return docs;
  }

  public static setDocuments(response, data, type: string) {
    let categorys_payment = new Array();
    let indice_val = new Array();
    let found_incidents = false;
    for (let file of response) {
      if (file.metadata != null) {
        let indice = file.metadata.id;
        indice_val.push(indice);
        categorys_payment.push({ purchase_order_payment_proof: { main_document_id: file.id.toString() } });

        data[indice] = {
          id: file.metadata.id,
          label: type,
          reference_date: file.metadata.reference_date,
          ternure: file,
          ternure_id: file.id,
          annex: file.metadata.annex,
        };

        if (file?.status == "rejected") {
          found_incidents = true;
        }
      }
    }
    return { data, categorys_payment, indice_val, found_incidents };
  }

  public static setDocumentsPayment(response, data, type: string) {
    for (var i in response) {
      if (response[i].metadata != null) {
        let indice = response[i].metadata?.id;
        if (data[indice] != undefined) {
          data[indice].id = response[i].metadata?.id;
          data[indice].label = type;
          data[indice].payment = response[i];
          data[indice].payment_id = response[i].id;
          data[indice].ternure_id = response[i].metadata?.main_document_id;
        }
      }
    }
    return data;
  }

  public static getProcedure(data) {
    return {
      id: data?.id,
      reference_date: data?.reference_date,
      annex: data?.annex,
    };
  }

  public static getPayment(data, payment_proof) {
    return {
      id: data?.id,
      main_document_id: data?.ternure?.id,
      payment_proof_of: payment_proof,
    };
  }

  public static getTitle(condition, title_true, title_false) {
    return condition ? title_true : title_false;
  }

  public static sortIndex(data, key) {
    let sorting = new Array();
    for (var i in data) {
      if (data[i]) {
        let indice = data[i][key].metadata.id;
        sorting[indice] = data[i];
      }
    }
    return sorting;
  }

  public static filesComplete(data, key) {
    let disabled = false;
    for (var i in data) {
      let doc = data[i];
      if (doc && doc[key] == null) {
        disabled = true;
        break;
      }
    }
    return disabled;
  }

  public static formatDate(date_text: string) {
    if (date_text == null) {
      return;
    }

    let date_split = date_text.split("-");
    let date_string = date_split[2] + "-" + date_split[1] + "-" + date_split[0] + "T00:00:00";
    let date_now = new Date(date_string);
    return date_now;
  }

  public static searchAnswer(questions, name_control) {
    if (questions == undefined) {
      return;
    }
    return questions.find((obj) => obj.control == name_control);
  }

  public static searchKey(questions, name_control) {
    let key_found = null;
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].control == name_control) {
        key_found = i;
        break;
      }
    }
    return key_found;
  }

  public static preparedIncidents(file) {
    let incidents = [];
    if (file?.metadata?.overallIncident) {
      incidents.push({
        incident: file?.metadata?.overallIncident,
        data: { title: "Instrucciones Generales:", date: file?.metadata?.bill_date },
      });
    }
    if (!file?.metadata?.questions_resolved) {
      incidents.push({
        incident: file.metadata?.comment,
        data: { title: "Documento faltante" },
      });
    } else {
      for (let question of file?.metadata?.questions_resolved) {
        if (question?.answer?.incident && question?.answer?.incident_text != undefined) {
          incidents.push({ incident: question?.answer?.incident_text, data: { title: "", date: "" } });
        }
        if (question?.answer?.complement_value) {
          incidents.push({ incident: question?.answer?.complement_value, data: { title: "", date: "" } });
        }
      }
    }
    return incidents;
  }

  public static searchAllAproved(files) {
    let allAproved = true;
    let statusInvalid = ["rejected", "sent"];
    for (let id in files) {
      if (statusInvalid.includes(files[id].status)) {
        allAproved = false;
        break;
      }
    }
    if (files.length == 0) {
      allAproved = false;
    }
    return allAproved;
  }

  public static countFiles(docs, key_primary: string, key_secundary: string) {
    let numberFiles = 0;
    for (var i in docs) {
      if (docs[i] != undefined) {
        if (docs[i].hasOwnProperty(key_primary) && docs[i][key_primary]?.id) {
          numberFiles++;
        }
        if (docs[i].hasOwnProperty(key_secundary) && docs[i][key_secundary]?.id) {
          numberFiles++;
        }
      }
    }
    return numberFiles;
  }

  public static getQuestion(questions, question_validation) {
    return questions[PurchaseOrderUtils.searchKey(questions, question_validation)];
  }

  public static getOverallIncident(files) {
    return files.filter((f) => {
      if (f.metadata?.overallIncident) return f;
    })[0]?.metadata?.overallIncident;
  }

  public static sortArrayDate(dateA, dateB, ordering = "asc", format = "DD-MM-YYYY") {
    const formats = [format];
    return (
      (moment(dateA, formats).isBefore(moment(dateB, formats))
        ? -1
        : moment(dateA, formats).isAfter(moment(dateB, formats))
        ? 1
        : 0) * (ordering === "asc" ? 1 : -1)
    );
  }

  public static readonly data_dot_status: Record<string, { label: string; style: string }> = {
    created: { label: "Nueva", style: "bg-slate-grey" },
    requested: { label: "En revisión", style: "bg-warm-blue" },
    sent: { label: "Enviada", style: "bg-secondary" },
    automatic_sent: { label: "Enviada automáticamente", style: "bg-secondary" },
    missing_documents: { label: "Incidencias asignadas al especialista", style: "bg-warning" },
    documents_validation: { label: "En validación", style: "bg-slate-grey" },
  };

  public static transformPurchaseOrderResponse(response: any): any {
    //set display_status to status by default
    let display_status = response?.status;

    // Transform to documents_validation when status is "created" and processing is true
    if (response?.status === "created" && response?.processing === true) {
      display_status = "documents_validation";
    }

    return { ...response, display_status };
  }
}
